export default __webpack_public_path__ + "img/a933c651a53c78fc92dccdc29aa62125.svg";